<template>
  <div class="not-found">
    <h1>404: Not Found This Page!</h1>
    <p><router-link :to="{ name: 'login' }">to: TOP</router-link></p>
  </div>
</template>

<script>
export default {};
</script>
